<template>
  <div>
    <p class="text-sm text-gray-700 px-2 font-bold">{{ feature.properties.name }}</p>
    <p class="text-sm text-gray-700 px-2 font-bold">{{ feature.properties.description }}</p>
      <div class="table w-full">
        <div class="table-row-group">
            <div class="table-row" v-for="obs in observations" :key="obs.component">
              <div class="table-cell bg-gray-400 text-gray-700 px-2">{{ obs.component}}</div>
              <div class="table-cell bg-gray-400 text-gray-700 px-2">{{ obs.value}} {{ obs.unit}}</div>
              <div class="table-cell bg-gray-400 text-gray-700 px-2">{{ obs.timestamp_from_epoch | epochToDate }}</div>
              <div class="table-cell bg-gray-400 text-gray-700 px-2">{{ obs.timestamp_to_epoch | epochToDate }}</div>
            </div>
        </div>
    </div>
    <button class="plotbtn" @click="onPlot">Plot data</button>
  </div>
</template>

<script>
import Vue from 'vue'
import Notify from "@/helpers/notify";
import ObservationsService from "@/helpers/apiservices/observations/observations.service";
import { LButton } from "@/components/forms";
import router from "../../../router"
import * as moment from "moment";

export default Vue.extend({
   components: {
    LButton 
  },
  props: {
    feature: {
      required: true,
      type: Object,
    },
    sensor:{type: Object}
  },
  data() {
    return {
      observations: [],
    };
  },
  mounted() {
    Notify.loadData(null, this.loadInitialData);
  },
  filters: {
    epochToDate: function (epoch) {
      return moment.unix(epoch).utc().format('YYYY-MM-DD HH:mm') + "Z";
    }
  },
  methods: {
    async loadInitialData () {
      this.observations = await ObservationsService.sensorobservations(
        {
          sensorid: this.feature.properties.id, 
          providerid: this.feature.properties.providerid
        });
    },
    onPlot() {
      var plotsensors = [];
      plotsensors.push(this.sensor);

      router.push({
          name: 'ObservationsPlot',
          params: {
              sensors: plotsensors
          }
      });
    }
  },
})
</script>

<style lang="scss" scoped>
  div{
    background-color:lightgray

  }
  .plotbtn{
    padding-top: 10px;
    padding-left: 10px;
    font-weight: bold;
    font-size: 14px;
    color: orangered;
  }
</style>>

</style>
